import axios from 'axios';
import store from '@/store';
import { Module, VuexModule, Mutation, Action } from 'vuex-module-decorators';
import { Endpoints, Mutations } from '@/ts/store/Constants';
import ErrorResponse from '@/ts/ErrorResponse';

@Module({name: 'Categories', namespaced: true})
export default class Categories extends VuexModule {
    public documentCategories: any = [];
    public activeCategory: any = null;
    public createDocumentWithCategory: boolean = false;

    @Mutation
    public RESET_CATEGORIES_STORE_STATE() {
        this.documentCategories         = [];
        this.activeCategory             = null;
        this.createDocumentWithCategory = false;
    }

    get getDocumentCategories() {
        return this.documentCategories;
    }

    get getActiveCategory() {
        return this.activeCategory;
    }

    get getCreateDocumentWithCategory() {
        return this.createDocumentWithCategory;
    }

    @Action
    public FETCH_DOCUMENT_CATEGORIES(data: any) {
        axios.get(Endpoints.Admin.Documents.FETCH_DOCUMENT_CATEGORIES)
            .then((response) => {
                store.commit(Mutations.SET_DOCUMENT_CATEGORIES, response.data.data);
            })
            .catch((error) => {
                if (error.response) {
                    const errorResponse = new ErrorResponse(error.response.status, error.response.data.message);
                    store.commit(Mutations.ADD_ERROR_RESPONSE, errorResponse);
                } else {
                    console.log(error);
                }
            });
    }

    @Mutation
    public SET_DOCUMENT_CATEGORIES(categories: any) {
        this.documentCategories = categories;
    }

    @Mutation
    public SET_ACTIVE_CATEGORY(category: any) {
        this.activeCategory = category;
    }

    @Mutation
    public SET_CREATE_DOCUMENT_WITH_CATEGORY(status: boolean) {
        this.createDocumentWithCategory = status;
    }
}

